import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { ClientDetails } from './ClientDetails';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';

export const Clients = () => {
  const [search, setSearch] = useState('');
  const [staffMemberId] = useState(
    localStorage.getItem('staffMemberId'),
  );
  const [searchPastBuyer, setSearchPastBuyer] = useState(null);
  //PastBuyerRef will always have a reference of searchPastBuyer value
  const pastBuyerRef = useRef();
  pastBuyerRef.current = searchPastBuyer;
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'My Clients';
    window.scrollTo(0, 0);
    refetch();
  }, [searchPastBuyer]);

  const fetchClients = () => {
    const options = {
      method: 'POST',
      url: '/buyer/getmobilebuyerlist',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        negotiatorId: staffMemberId,
        searchPastBuyers: pastBuyerRef.current,
      }),
    };

    return axios
      .request(options)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw new Error('Server error');
      });
  };

  const handleSearchPastBuyerChange = (event) => {
    event.preventDefault();
    event.persist();
    if (searchPastBuyer == event.target.dataset.searchpastbuyer) {
      setSearchPastBuyer(null);
      return;
    }
    setSearchPastBuyer(event.target.dataset.searchpastbuyer);
  };

  const {
    isLoading: isLoadingClients,
    isError,
    data: ClientsData,
    refetch
  } = useQuery('ClientsData', fetchClients, {
    refetchOnWindowFocus: false,
    enabled: false // turned off by default, manual refetch is needed
  });

  const filterClient = (clients, search) => {
    if (!search) {
      return clients;
    }

    return clients.filter((client) => {
      if (client?.address?.addressIndividualFirstName != null || client?.address?.addressOrganisationName != null) {
        return (
          client?.address?.addressIndividualFirstName
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          client?.address?.addressIndividualSurname
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          client?.address?.addressOrganisationName
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          client?.buyerSpec?.buyerSpecName
            .toLowerCase()
            .includes(search.toLowerCase())
        );
      }
    });
  };

  const filterClients = filterClient(ClientsData, search);

  if (isLoadingClients) {
    return (
      <div className="container">
        <div className="row justify-content-center align-items-center vh-100">
          <Loader
            type="TailSpin"
            color="black"
            height="50"
            width="50"
          />
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="container">
        <div className="row justify-content-center align-items-center vh-100">
          <h1>Server is down, please try again later </h1>
        </div>
      </div>
    );
  }

  return (
    <div className="container p-0">
      <div className="row justify-content-center align-items-center">
      <div className="col-9 col-md-9 col-xl-9">
        <div className="h4 mb-3 ml-0 font-weight-bold">
            My Clients
          </div>
        </div>
        <div className="col-3 col-md-3 col-xl-3 text-right">
        <p className="btn btn-danger d-block mb-4" onClick={() => navigate(-1)}>
            Back
        </p>
        </div>
        <div className="col-12 col-md-12 col-xl-12">
          <div className="h6 mb-3 ml-0">
            You have{' '}
            {filterClients?.length > 1
              ? `${filterClients?.length} clients`
              : `${filterClients?.length} client`}
          </div>
          <div className='row'>
            <div className='col-md-8'>
                <div className="form-group has-search">
                  <span className="fa fa-search form-control-feedback"></span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
              </div>
            </div>

            <div className="col-md-4 mb-4">
              <div className="d-flex justify-content-center align-items-center">
                <div
                  className={`button-belair w-100 ${
                    searchPastBuyer !== 'true' ? 'blend' : ''
                  }`}
                  onClick={handleSearchPastBuyerChange}
                  data-searchPastBuyer="false"
                >
                  Current Clients
                </div>

                <div
                  className={`button-belair w-100 ${
                    searchPastBuyer === 'true' ? 'blend' : ''
                  }`}
                  onClick={handleSearchPastBuyerChange}
                  data-searchPastBuyer="true"
                >
                  Past Clients
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
      <div className="row justify-content-center align-items-center">
        {filterClients?.length < 1 ? (
          <h4>No search results found</h4>
        ) : null}
        <div className="col-12 col-md-12 col-xl-12">
          <div className="form-group mt-4">
            <div className="pb-4">
              {filterClients &&
                React.Children.toArray(
                  filterClients?.map((contact) => (
                    <div className="border-bottom">
                      <ClientDetails contact={{ contact }} />
                    </div>
                  )),
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
